// @TODO <HEALTH2019>
App.controller('ZochHealthInsuranceOccurrenceCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'insuranceService', '$filter', '$rootScope', 'zochaHealthInsuranceService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaInsuranceService, $timeout, $stateParams, Blob, FileSaver, insuranceService, $filter, $rootScope, zochaHealthInsuranceService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Wystąpienie'; 
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.healthInsurance.list';
    $scope.$emit('link', $scope.link);

    if (!$scope.stateParams.declaration) {
        $state.go('root.home.zoch.healthInsurance.list');
    }

    $scope.maxDate = new Date();
    $scope.dateOfDeath = new Date();
    $scope.declaration = $scope.stateParams.declaration;
    $scope.reason = 'EMPLOYEE_RESIGNATION';

    if ($scope.declaration.status === 'WITHDRAWN') {
        $scope.reason = $scope.declaration.withdrawalReason;
        $scope.dateOfDeath = $scope.declaration.dateOfDeath;
    }

    $scope.withdraw = function() {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        var criteria = {
            id: $scope.stateParams.declaration.id,
            data: {
                reason: $scope.reason
            }
        }

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $filter('getDateFromBirthdate')($scope.dateOfDeath);
        }
// @TODO <HEALTH2019>
        zochaHealthInsuranceService.withdraw(criteria).then(function (data) {
            if (data.status === 200) {
                $state.go('root.home.zoch.healthInsurance.list');
            }
        });

// @TODO </HEALTH2019>
    }
}]);
